import { Layer } from 'ui/components/Layer'
import { Page } from 'ui/components/Page'

import { Actions, Filter, Table } from './components'
import { DocumentsListContextProvider } from './context/DocumentListContextProvider'

const DocumentList = () => (
  <DocumentsListContextProvider>
    <Page title="Documents" actions={<Actions />}>
      <Layer rounded shadowed stretch>
        <Filter />
        <Table />
      </Layer>
    </Page>
  </DocumentsListContextProvider>
)

export default DocumentList
